import type MsJSClient from '@wolfejs/ms-api-js/src';
import { PGCorpCandidateOrderPayload } from '@wolfejs/ms-api-js/src/types/orders';

/**
 * A candidate order in PG corp IS the cart. A new candidate order is created every time a user edits items in their "cart".
 * These functions are to use in server components and in custom hooks for queryFn as needed.
 */
export async function createCandidateOrder(client: MsJSClient, payload: PGCorpCandidateOrderPayload) {
  const { data } = await client.orders.candidateOrder(payload);
  return data;
}

export async function getCandidateOrder(client: MsJSClient, id: string) {
  const { data } = await client.orders.getCandidateOrder(id);
  return data;
}
